export class VendorRegister {
  public VendorKey: string;
  public UserId: string;
  public Password: string;
  public ConfirmPassword: string;
  public SecretQuestion: string;
  public SecretAnswer: string;
  public CompanyName: string;
  public ContactFirstName: string;
  public ContactLastName: string;
  public Phone: string;
  public Fax: string;
  public Email: string;
  public IsAgreement: boolean;
  public IsLikeToReceivePaymentElectronically: boolean;
  public UniversalEmail: string;
  public  UniversalGuid: string;
  public universalFlag: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/VendorRegister.ts